exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg[data-v-abc9f7ae] {\r\n  color: inherit;\r\n  display: inline-block;\r\n  fill: currentColor;\r\n  vertical-align: middle;\r\n  width: inherit;\r\n  height: inherit;\n}\r\n", ""]);

// exports
